var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.80052 3.83428C9.57169 1.26048 13.9046 1.42048 16.4784 4.19164L20.9168 8.97034C23.4906 11.7415 23.3306 16.0744 20.5594 18.6482C17.7883 21.222 13.4553 21.0621 10.8815 18.2909L6.44317 13.5122C3.86937 10.741 4.02936 6.40808 6.80052 3.83428Z",
    fill: "url(#paint0_linear_1_13056)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2251 15.7833C17.3697 15.6871 17.5359 15.6285 17.7088 15.6128C17.8816 15.5971 18.0557 15.6247 18.2152 15.6933L24.3666 18.4494C24.5739 18.538 24.747 18.6914 24.8598 18.8865C24.9727 19.0817 25.0193 19.3082 24.9927 19.532C24.7901 21.0465 24.0443 22.4358 22.8941 23.4416C21.7438 24.4474 20.2675 25.0012 18.7395 25C14.0347 25 9.5226 23.131 6.19579 19.8042C2.86898 16.4774 1 11.9653 1 7.26047C0.998833 5.73253 1.55264 4.25616 2.55842 3.10594C3.5642 1.95572 4.95351 1.20994 6.46795 1.00729C6.69182 0.980692 6.91829 1.02732 7.11345 1.14018C7.30862 1.25305 7.46198 1.42608 7.55058 1.63339L10.3067 7.79005C10.3745 7.94818 10.402 8.12059 10.387 8.29195C10.372 8.46332 10.3148 8.62831 10.2206 8.77224L7.43319 12.0867C7.33431 12.2359 7.27584 12.4082 7.2635 12.5867C7.25115 12.7653 7.28535 12.944 7.36275 13.1054C8.44147 15.3137 10.7241 17.569 12.939 18.6372C13.1012 18.7143 13.2807 18.7477 13.4598 18.7342C13.6389 18.7208 13.8114 18.6608 13.9603 18.5603L17.2251 15.7833Z",
    stroke: "#1D252B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_13056",
    x1: 13.68,
    y1: 2.00391,
    x2: 13.68,
    y2: 20.4786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA543"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCC83"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallIcon);
export default __webpack_public_path__ + "static/media/call-icon.870a85a5336a9a976f2f985e85db8fc8.svg";
export { ForwardRef as ReactComponent };